import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/pro-light-svg-icons";

export const HelpButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Tooltip title={t("help.helpCenter")}>
      <IconButton onClick={() => navigate("/admin/help")}>
        <SvgIcon>
          <FontAwesomeIcon icon={faCircleQuestion} />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
